const routerNames = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  CONFIRM_MAIL: 'CONFIRM_MAIL',
  CONFIRM_MAIL_FORGOT: 'CONFIRM_MAIL_FORGOT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  NEW_PASSWORD: 'NEW_PASSWORD',
  STEP_INFORMATION: 'STEP_INFORMATION',
  STEP_UPLOAD: 'STEP_UPLOAD',
  STEP_PERSPECTIVE_DELIVERY: 'STEP_PERSPECTIVE_DELIVERY',
  STEP_VIEWER: 'STEP_VIEWER',
  STEP_CONFIRMATION: 'STEP_CONFIRMATION',
  STEP_COMPLETED: 'STEP_COMPLETED',
  PLAN: 'PLAN',
  PROJECT: 'PROJECT',
  DETAIL_PROJECT: 'DETAIL_PROJECT',
  FEEDBACK_AND_ADDITION: 'FEEDBACK_AND_ADDITION',
  FEEDBACK_AND_ADDITION_CONFIRM: 'FEEDBACK_AND_ADDITION_CONFIRM',
  CREATE_PROJECT: 'CREATE_PROJECT',
  MY_ACCOUNT: 'MY_ACCOUNT',
  MY_ACCOUNT_EDIT_INFO: 'MY_ACCOUNT_EDIT_INFO',
  MY_ACCOUNT_EDIT_PASSWORD: 'MY_ACCOUNT_EDIT_PASSWORD',
  MY_ACCOUNT_CHANGE_EMAIL: 'MY_ACCOUNT_CHANGE_EMAIL',
  MY_ACCOUNT_CHANGE_EMAIL_CONFIRM: 'MY_ACCOUNT_CHANGE_EMAIL_CONFIRM',
  MY_ACCOUNT_LEAVE: 'MY_ACCOUNT_LEAVE',
  MESSAGE: 'MESSAGE',
  PORTFOLIO: 'PORTFOLIO'
} as const

export const routerGroups: Record<string, readonly RouteNames[]> = {
  AUTH: [
    routerNames.LOGIN,
    routerNames.REGISTER,
    routerNames.NEW_PASSWORD,
    routerNames.FORGOT_PASSWORD,
    routerNames.CONFIRM_MAIL,
    routerNames.CONFIRM_MAIL_FORGOT
  ],
  PROJECTS: [
    routerNames.PROJECT,
    routerNames.DETAIL_PROJECT,
    routerNames.FEEDBACK_AND_ADDITION,
    routerNames.FEEDBACK_AND_ADDITION_CONFIRM
  ],
  ACCOUNT: [
    routerNames.MY_ACCOUNT,
    routerNames.MY_ACCOUNT_EDIT_INFO,
    routerNames.MY_ACCOUNT_EDIT_PASSWORD,
    routerNames.MY_ACCOUNT_CHANGE_EMAIL,
    routerNames.MY_ACCOUNT_CHANGE_EMAIL_CONFIRM
  ],
  MESSAGES: [routerNames.MESSAGE],
  PLANS: [routerNames.PLAN],
  PORTFOLIO: [routerNames.PORTFOLIO]
}

export default routerNames

export type RouteNames = (typeof routerNames)[keyof typeof routerNames]

export const loginPath = '/login'
export const homePath = '/projects'
